import React from 'react'
import '../Trip/customShimar.css';

export default function CustomShimar() {

    // const mapped = Array.from({ length: 10 }).map((el) => {
    //     return 'ajay';
    // })
    // console.log(mapped);

    return (
        <div className='testimonial-section products col-md-12'>
            <div className="slider-sec">
                <h2></h2>
                {Array.from({ length: 4 }).map((el, i) => {
                    return <div key={i} className="slider-main shimmar" >
                        {/* <img loading="lazy" src="" alt="Alps"  /> */}
                        <div className="testimonial-block product">
                            <div className="discount-block skelton">
                                {/* <p>The Italian / Austrian Alps</p> */}
                                <div className="discount-content things">

                                </div>
                            </div>
                        </div>
                    </div>

                })}
            </div>
        </div>
    )
}
